import { REGEX_EXPS } from "utils/constants";
import { normalizeTextField } from "utils/helpers/validations";

const isPersonName = (value) => {
  const normalized = normalizeTextField(value);
  return typeof normalized === "string" && REGEX_EXPS.name.test(normalized);
};

const socialSecurityDigitCount = (value) =>
  String(value || "").replace(/[\s.\-_/]/g, "").length;

export const isSpouseEntryComplete = (spouse) => {
  const user = spouse?.identity?.user;
  if (!user?.gender) return false;
  if (!isPersonName(user.lastname) || !isPersonName(user.firstname)) {
    return false;
  }
  return (
    socialSecurityDigitCount(spouse?.identity?.socialSecurityNumber) === 15
  );
};

export const sectionsAfterSpouseEntry = ({
  spouseComplete,
  childCount,
  alreadyOpened,
}) => {
  if (!spouseComplete || childCount < 1 || alreadyOpened) return null;
  return { 0: true };
};

export const initialRelatedPersonSections = ({
  hasSpouse,
  childCount,
  spouseComplete,
}) => {
  const openFirstChild = childCount > 0 && (!hasSpouse || spouseComplete);
  if (!hasSpouse) {
    return openFirstChild ? { spouse: false, 0: true } : { spouse: false };
  }
  if (openFirstChild) return { spouse: true, 0: true };
  return { spouse: true };
};
